import React from 'react';
import Icon from '@common/assets';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const EmptySearchChat = () => {
  return (
    <div className={cx('emptyArea')}>
      <Icon name="joyEmpty" width={80} height={80} />
      <span className={cx('title')}>아직 해당하는 기업 채팅이 없어요...</span>
      <span className={cx('desc')}>다른 채팅도 한번 살펴보는 건 어떨까요?</span>
    </div>
  );
};

export default EmptySearchChat;
